import { render, staticRenderFns } from "./Standards.vue?vue&type=template&id=d0d60ee8&scoped=true"
import script from "./Standards.vue?vue&type=script&lang=ts"
export * from "./Standards.vue?vue&type=script&lang=ts"
import style0 from "./Standards.vue?vue&type=style&index=0&id=d0d60ee8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d60ee8",
  null
  
)

export default component.exports